/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <GlobalGraph class="graph" v-if="series.length" :series="computedSeries" :xAxisData="xAxis" :yAxis="yAxis" :theme="theme" :isOnClickValueRequired="true" />
</template>

<script>
import _ from 'lodash'
import {
  mapGettersMixin
} from '@/util/mixin/index'
import GlobalGraph from '@/components/common/GlobalGraph.vue'
import Inverter from '@/services/Inverter'
import { mapGetters, mapMutations } from 'vuex'
const moment = require('moment')

export default {
  props: ['date', 'type', 'blockId', 'invRoom', 'blockLevel', 'graph', 'plantYield', 'isMultipleDays'],
  mixins: [ mapGettersMixin ],
  components: {
    GlobalGraph
  },
  data() {
    return {
      series: [],
      xAxis: []
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    watchParamEnabled() {
      return `${this.date[0]} ${this.date[1]} ${this.getSelectedPlantId} ${this.blockId} ${this.invRoom} ${this.type} ${this.plantYield}`
    },
    yAxis() {
      return [{
          type: 'value',
          name: this.$t('Generation (kWh)'),
          min: 0,
          position: 'right',
          axisLabel: {
            formatter: '{value}',
            rotate: 40
          }
        },
        {
          type: 'value',
          name: this.$t('Irradiance (W/m²)'),
          min: 0,
          position: 'left',
          axisLabel: {
            formatter: '{value}',
            rotate: 40
          }
        }
      ]
    },
    computedSeries() {
      const cloneSeries = _.cloneDeep(this.series)
      return cloneSeries.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    }
  },
  created() {
    this.setIntervalWithoutDelay(this.callAllApi)
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_PROGRESS_BAR'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getGeneration()
    },
    async getGeneration() {
      const yieldNameMap = {
        energy: 0,
        yield: 1
      }
      if (this.getSelectedPlantId && this.blockId && this.type && this.date.length > 0) {
        try {
          let param = {
            plantId: this.getSelectedPlantId,
            blockId: this.blockId,
            type: this.type,
            blockLevel: this.blockLevel,
            inverterRoom: this.invRoom,
            dateFrom: moment(this.date[0]).format('YYYY-MM-DD'),
            dateTo: moment(this.date[1]).format('YYYY-MM-DD'),
            plantYield: yieldNameMap[this.plantYield]
          }
          this.SET_PROGRESS_BAR(true)
          let response = await Inverter.inverterEnergy(param)

          this.SET_PROGRESS_BAR(false)
          this.series = response.data.message.data
          this.xAxis = response.data.message.axis
          // var total = 0
          // response.data.message.data.forEach(element => {
          //   if (element.name !== 'Irradiance') {
          //     total += element.data.reduce(
          //       (accumulator, currentValue) =>
          //         accumulator + parseFloat(currentValue),
          //       0
          //     )
          //   }
          // })
        } catch (err) {
          this.SET_PROGRESS_BAR(false)
        }
      }
    }
  },
  watch: {
    watchParamEnabled() {
      this.setIntervalWithoutDelay(this.callAllApi)
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }
}
</script>

<style scoped>
  .graph {
    width: 100%;
    height: 400px;
  }
</style>
